import { Box, Text } from "@chakra-ui/react";

const tag_color = (tag_name) => {
  const lower_tag_name = tag_name?.toLowerCase();
  switch (lower_tag_name) {
    case "hot":
      return "linear(to-r, #eb0200, #ff9726)";
    case "new":
      return "linear(to-r, green-700, green.400)";
    default:
      return "linear(to-r, #eb0200, #ff9726)";
  }
};

const GameTag = ({ game_tags_props = [] } = {}) => {
  return (
    <Box
      position={`absolute`}
      top={{
        base: "5px",
        lg: "10px",
      }}
      left={{
        base: "5px",
        lg: "10px",
      }}
      zIndex={`1`}
      display="flex"
      gap="5px"
    >
      {game_tags_props?.map((tag) => {
        const split_tag = tag?.split("_");
        const tag_name = split_tag?.[0];
        const tag_number = split_tag?.[1];

        const bgColor = tag_color(tag_name);

        return (
          <Box
            gap="2.5px"
            minW={`55px`}
            py={{
              base: "2.5px",
              md: "5px",
            }}
            px="5px"
            borderRadius={`full`}
            alignItems={`center`}
            justifyContent={`center`}
            fontWeight={`bold`}
            color="white"
            bgGradient={bgColor}
            display="flex"
          >
            <Text
              as="span"
              fontSize={{
                base: "sm",
                md: `md`,
              }}
              letterSpacing={`tighter`}
            >
              {tag_name?.toUpperCase()}{" "}
            </Text>
            <Text
              fontSize={{
                base: "sm",
                md: `md`,
              }}
              as="span"
            >
              #{tag_number}
            </Text>
          </Box>
        );
      })}
    </Box>
  );
};

export default GameTag;
